import type { AppDescriptorDTO } from "../api/types.js";

/**
 * Bringt die Bereiche in die vom Benutzer gewählte Reihenfolge.
 *
 * Die gespeicherte Liste ist nur ein Wunsch, keine Wahrheit: Apps, die es nicht mehr
 * gibt, werden übergangen, und neu hinzugekommene hängen hinten an. So bleibt eine
 * einmal gespeicherte Reihenfolge auch dann brauchbar, wenn buma wächst.
 */
export function orderApps(
  apps: readonly AppDescriptorDTO[],
  order: readonly string[] | undefined,
): AppDescriptorDTO[] {
  if (!order || order.length === 0) {
    return [...apps];
  }

  const byId = new Map(apps.map((app) => [app.id, app]));
  const sorted: AppDescriptorDTO[] = [];

  for (const id of order) {
    const app = byId.get(id);
    if (app) {
      sorted.push(app);
      byId.delete(id);
    }
  }

  // Was die Reihenfolge nicht kennt, behält seine ursprüngliche Position untereinander.
  for (const app of apps) {
    const remaining = byId.get(app.id);
    if (remaining) {
      sorted.push(remaining);
    }
  }

  return sorted;
}

/** Verschiebt einen Eintrag an eine neue Stelle und gibt die Ids in neuer Folge zurück. */
export function moveApp(
  apps: readonly AppDescriptorDTO[],
  activeId: string,
  overId: string,
): string[] {
  const ids = apps.map((app) => app.id);
  const from = ids.indexOf(activeId);
  const to = ids.indexOf(overId);
  if (from === -1 || to === -1 || from === to) {
    return ids;
  }
  const next = [...ids];
  next.splice(from, 1);
  next.splice(to, 0, activeId);
  return next;
}
